import React from 'react'

import { UserAvatar } from '@avantstay/backoffice-core'

import { OmniSearchHomeowner } from '../../../OmniSearch.types'
import * as S from './UserDetail.styles'

export interface HomeownerDetailProps {
  homeowner: OmniSearchHomeowner
}

export function HomeownerDetail({ homeowner }: HomeownerDetailProps): JSX.Element {
  const { fullName, email } = homeowner

  return (
    <S.UserDetail>
      <S.UserDetailColumn>
        <UserAvatar alt={fullName} size={35} isActive solid />
      </S.UserDetailColumn>
      <S.UserDetailColumn>
        <S.DetailTitle>{fullName}</S.DetailTitle>
        <S.DetailSubtitle>{email}</S.DetailSubtitle>
      </S.UserDetailColumn>
    </S.UserDetail>
  )
}
